import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { X } from 'lucide-react';
import DriverProfileTab from './DriverProfileTab';
import DriverLocationTab from './DriverLocationTab';
import DriverMetricsTab from './DriverMetricsTab';
import DriverDeliveriesTab from './DriverDeliveriesTab';

const API_URL = process.env.REACT_APP_API_URL;

function DriverDetailModal({ driverId, onClose, onDriverUpdated }) {
  const [activeTab, setActiveTab] = useState('profile');
  const [driverData, setDriverData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchDriverDetails();
  }, [driverId]);

  async function fetchDriverDetails() {
    try {
      setLoading(true);
      const response = await axios.get(`${API_URL}/api/admin/drivers/${driverId}`);
      setDriverData(response.data);
    } catch (error) {
      console.error('Error fetching driver details:', error);
      alert('Error al cargar detalles del conductor');
    } finally {
      setLoading(false);
    }
  }

  function handleDriverUpdated() {
    fetchDriverDetails();
    onDriverUpdated();
  }

  const tabs = [
    { id: 'profile', label: 'Perfil', icon: '👤' },
    { id: 'location', label: 'Ubicación', icon: '📍' },
    { id: 'metrics', label: 'Métricas', icon: '📊' },
    { id: 'deliveries', label: 'Entregas', icon: '📦' }
  ];

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-5xl max-h-[90vh] overflow-hidden flex flex-col">
        {/* Header */}
        <div className="bg-gradient-to-r from-[#B1336E] to-[#B1336E]/80 px-6 py-4 flex items-center justify-between">
          <h2 className="text-2xl font-bold text-white font-montserrat">
            Detalles del Conductor
          </h2>
          <button
            onClick={onClose}
            className="p-2 hover:bg-white/20 rounded-lg transition-colors"
          >
            <X className="w-6 h-6 text-white" />
          </button>
        </div>

        {/* Tabs */}
        <div className="border-b border-slate-200 px-6">
          <div className="flex gap-1 -mb-px overflow-x-auto">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`
                  px-6 py-3 font-semibold font-montserrat transition-all whitespace-nowrap
                  ${activeTab === tab.id
                    ? 'text-[#B1336E] border-b-2 border-[#B1336E]'
                    : 'text-slate-500 hover:text-slate-700'
                  }
                `}
              >
                <span className="mr-2">{tab.icon}</span>
                {tab.label}
              </button>
            ))}
          </div>
        </div>

        {/* Content */}
        <div className="flex-1 overflow-y-auto p-6">
          {loading ? (
            <div className="flex items-center justify-center h-64">
              <div className="text-center">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#B1336E] mx-auto"></div>
                <p className="mt-4 text-slate-600 font-montserrat">Cargando información...</p>
              </div>
            </div>
          ) : (
            <>
              {activeTab === 'profile' && (
                <DriverProfileTab
                  driverData={driverData}
                  driverId={driverId}
                  onUpdate={handleDriverUpdated}
                />
              )}
              {activeTab === 'location' && (
                <DriverLocationTab
                  driverData={driverData}
                  driverId={driverId}
                  onUpdate={handleDriverUpdated}
                />
              )}
              {activeTab === 'metrics' && (
                <DriverMetricsTab
                  driverData={driverData}
                  driverId={driverId}
                />
              )}
              {activeTab === 'deliveries' && (
                <DriverDeliveriesTab
                  driverData={driverData}
                  driverId={driverId}
                />
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default DriverDetailModal;